import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function HomePage() {
  const { user, membership, teamspaces } = useAuth();

  if (!membership) {
    return (
      <div className="empty">
        <div className="big">🧩</div>
        <div style={{ fontSize: 16, color: 'var(--text)' }}>워크스페이스 멤버가 아닙니다</div>
        <div className="muted">{user?.email} · 관리자에게 초대를 요청하세요.</div>
      </div>
    );
  }

  return (
    <div className="empty">
      <div className="big">👋</div>
      <div style={{ fontSize: 18, color: 'var(--text)' }}>
        <b>{membership.display_name || user?.email}</b> 님, 환영합니다.
      </div>
      <div>왼쪽에서 페이지를 선택하거나 <b>＋ 새 페이지</b>로 문서를 만들어 보세요.</div>
      <div className="muted" style={{ fontSize: 12 }}>
        조직 <b>{membership.org_name}</b> · 팀스페이스 {teamspaces.length}개 · 로그인 {user?.email}
      </div>
      <div style={{ display: 'flex', gap: 8, marginTop: 10, flexWrap: 'wrap', justifyContent: 'center' }}>
        {(membership.role === 'owner' || membership.role === 'admin') && (
          <Link className="chip" to="/admin/members">멤버·초대 관리 →</Link>
        )}
        <Link className="chip" to="/import">노션에서 가져오기 →</Link>
      </div>
    </div>
  );
}
